
<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import { ChevronDown, ChevronUp, Icon } from 'svelte-hero-icons'

    import { type OpenaiExample } from '$lib/stores/openai_example/types'
	import { InitOpenaiExamples } from '$lib/stores/openai_examples/openai_examples'
	import { openai_examples_store } from '$lib/stores/openai_examples/openai_examples'

    import ButtonBase from '../Common/Buttons/ButtonBase.svelte'
	

	const dispatch = createEventDispatcher()

	export let showExamples: boolean = false


	let examples: OpenaiExample[] = []

	$: {
		examples = $openai_examples_store
	}


	onMount(async () => {
		InitOpenaiExamples()
	})

	function handleSwithView() {
		showExamples = !showExamples
		dispatch('switchView', showExamples)
	}

	function handleDispatch(text: string) {
		dispatch('useExample', text)
		handleSwithView()
	}

</script>




<div class='link examples flex flex-row !py-4 gap-1 '>
	<ButtonBase 
		type="secondary" class="switchView" on:click={handleSwithView}>
		<span class="flex items-center px-2">
			{#if showExamples}
				<Icon src={ChevronUp} class="h-5 w-5 " />
			{:else}
				<Icon src={ChevronDown} class="h-5 w-5 " />
			{/if}
		</span>
		Example questions
	</ButtonBase>

</div>
<!-- {#if showExamples} -->
<div class="examples-content flex flex-col" 
	class:visible={showExamples}>
	<span class="examples-header">
		Here are common questions you can ask the Al Assistant. Click any question to use it as your prompt:
	</span>
	{#each examples as example}	
		<p class="example-question link" 
			on:click={() => handleDispatch(example.question)}
			on:keydown={() => handleDispatch(example.question)}>
			{example.question}
		</p>
	{/each}
</div>


<style lang="postcss">

	.examples-content {
		padding-left: 35px;
		opacity: 0;
        max-height: 0;
        overflow: hidden;
        transition: opacity 0.5s ease, max-height 0.5s ease;
	}
	.examples-content.visible {
        opacity: 1;
        max-height:fit-content;
    }
	.examples-header {
		padding: 0px 0px 10px 0px;
	}
	.example-question {
		border-left: 3px solid #ccc;
		padding: 10px;
	}



</style>
